// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/agents/agents.actions.go

import { type ReactNode } from "react";
import { type Scope } from "~/hooks/useScope";
import { useCanGenerateRegistrationToken } from "./hook";

export type CanGenerateRegistrationTokenProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  scope?: Scope;
};

export function CanGenerateRegistrationToken({
  children,
  fallback,
  scope,
}: CanGenerateRegistrationTokenProps) {
  const canDoAction = useCanGenerateRegistrationToken(scope);
  return <>{canDoAction ? children : fallback}</>;
}
